import Vue from 'vue';
import Vuex from 'vuex';
import { Decrypt } from './config/mUtils';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    navigation: null,
    regionData: null,
  },
  getters: {
    GET_NAV(state, value) {
      return state.navigation
    },
    GET_REGION(state, value) {
      return state.regionData
    },
    GET_FRESHEN(state, value) {
      return state.newfreshen
    },
  },
  mutations: {
    SET_NAV(state, value) {
      state.navigation = value
    },
    SET_FRESHEN(state, value) {
      state.newfreshen = value
    },
    SET_REGION(state, value) {
      state.regionData = value
    },
    REGIONASS(state, value){
      let region = window.sessionStorage.getItem("region");
      if (region) {
        state.regionData = Decrypt(region);
      }
    },
  },
  actions: {},
});
